import {
  FILTER_POPULAR_IDEAS_LIST_START,
  FILTER_POPULAR_IDEAS_LIST_SUCCESS,
  FILTER_POPULAR_IDEAS_LIST_FAILED,
  FETCH_AI_COLOR_TYPE_START,
  FETCH_AI_COLOR_TYPE_SUCCESS,
  FETCH_AI_COLOR_TYPE_FAILED,
  FETCH_AI_DESIGN_STYLE_START,
  FETCH_AI_DESIGN_STYLE_SUCCESS,
  FETCH_AI_DESIGN_STYLE_FAILED,
  FETCH_AI_LANGUAGE_START,
  FETCH_AI_LANGUAGE_SUCCESS,
  FETCH_AI_LANGUAGE_FAILED,
  UPDATE_AI_DESIGNER_USAGE_START,
  UPDATE_AI_DESIGNER_USAGE_SUCCESS,
  UPDATE_AI_DESIGNER_USAGE_FAILED,
  FETCH_AI_DESIGNER_USAGE_START,
  FETCH_AI_DESIGNER_USAGE_SUCCESS,
  FETCH_AI_DESIGNER_USAGE_FAILED
} from "../actions/actionTypes";

export const aiDesignerReducer = (originalState = {}, action) => {
  const state = {
    ...originalState,
    type: action.type,
    flashMessage: null,
    status: action?.error?.response?.status ?? null,
  };

  switch (action.type) {
    case FILTER_POPULAR_IDEAS_LIST_START:
      return { ...state, filteredPopularIdeaListLoading: true };

    case FILTER_POPULAR_IDEAS_LIST_SUCCESS:
      return { ...state, filteredPopularIdeaListLoading: false, filteredOutPopularIdeasList: action.data.data };

    case FILTER_POPULAR_IDEAS_LIST_FAILED:
      return { ...state, filteredPopularIdeaListLoading: false };

    case FETCH_AI_COLOR_TYPE_START:
      return { ...state, filteredPopularIdeaListLoading: false };

    case FETCH_AI_COLOR_TYPE_SUCCESS:
      return { ...state, filteredPopularIdeaListLoading: false, colorTheme: action.data };

    case FETCH_AI_COLOR_TYPE_FAILED:
      return { ...state, filteredPopularIdeaListLoading: false };

      case FETCH_AI_DESIGN_STYLE_START:
      return { ...state, filteredPopularIdeaListLoading: false };

    case FETCH_AI_DESIGN_STYLE_SUCCESS:
      return { ...state, filteredPopularIdeaListLoading: false, designStyle: action.data.data };

    case FETCH_AI_DESIGN_STYLE_FAILED:
      return { ...state, filteredPopularIdeaListLoading: false };

    case FETCH_AI_LANGUAGE_START:
      return { ...state, filteredPopularIdeaListLoading: false };

    case FETCH_AI_LANGUAGE_SUCCESS:
      return { ...state, filteredPopularIdeaListLoading: false, aiLanguage: action.data.data };

    case FETCH_AI_LANGUAGE_FAILED:
      return { ...state, filteredPopularIdeaListLoading: false };

    case UPDATE_AI_DESIGNER_USAGE_START:
      return { ...state, filteredPopularIdeaListLoading: false };

    case UPDATE_AI_DESIGNER_USAGE_SUCCESS:
      return { ...state, filteredPopularIdeaListLoading: false };

    case UPDATE_AI_DESIGNER_USAGE_FAILED:
      return { ...state, filteredPopularIdeaListLoading: false };

    case FETCH_AI_DESIGNER_USAGE_START:
      return { ...state, filteredPopularIdeaListLoading: false };

    case FETCH_AI_DESIGNER_USAGE_SUCCESS:
      return { ...state, filteredPopularIdeaListLoading: false, aiDesignerUsageDetails : action.data };

    case FETCH_AI_DESIGNER_USAGE_FAILED:
      return { ...state, filteredPopularIdeaListLoading: false };

    default:
      return state;
  }
};
